import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Sparkles } from "lucide-react";

// Global, in-context upgrade prompt. The API interceptor dispatches an
// "openword:upgrade" event whenever a credit / Go Deeper limit (HTTP 402) is hit,
// so the nudge appears right at the moment of friction — no redirect hunting.
export const UpgradeNudge = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const onNudge = (e) => {
      setMessage(e.detail?.message || "You've reached the limit on your current plan.");
      setOpen(true);
    };
    window.addEventListener("openword:upgrade", onNudge);
    return () => window.removeEventListener("openword:upgrade", onNudge);
  }, []);

  const goToPlans = () => {
    setOpen(false);
    navigate("/billing");
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-md rounded-2xl" data-testid="upgrade-nudge">
        <DialogHeader>
          <div className="w-11 h-11 rounded-full bg-[#10222A] flex items-center justify-center mb-2">
            <Sparkles className="w-5 h-5 text-[#00E5FF]" strokeWidth={1.5} />
          </div>
          <DialogTitle className="text-2xl text-white">Keep going deeper</DialogTitle>
          <DialogDescription className="text-slate-400 leading-relaxed pt-1">
            {message}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-col sm:flex-col gap-2 sm:gap-2">
          <Button
            data-testid="upgrade-nudge-see-plans"
            onClick={goToPlans}
            className="w-full h-11 rounded-full bg-[#00E5FF] hover:bg-[#00B8CC] text-[#07090E]"
          >
            See plans
          </Button>
          <Button
            data-testid="upgrade-nudge-dismiss"
            onClick={() => setOpen(false)}
            variant="ghost"
            className="w-full h-10 rounded-full text-slate-400 hover:bg-[#141B29]"
          >
            Not now
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
